/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import {INTERFACE_ACTION_TYPE} from "@Actions/Interface";


export const CHANGE_API_REQUEST_STATUS:string = "CHANGE_API_REQUEST_STATUS";


export const CHANGE_API_REQUEST_STATUS_ACTION = (status: boolean = false): INTERFACE_ACTION_TYPE => {
    return {
        type: CHANGE_API_REQUEST_STATUS,
        status: status
    };
};


export default CHANGE_API_REQUEST_STATUS_ACTION;
